<template>
  <div class="container mb-4">
    <vue-headful
      :title="`ปืนทั้งหมด - Thong Firearms ร้านปืนธง`"
      image="https://thongarms.com/dist/logo.png"
      lang="th"
    />
    <!-- <div class="max-width mt-4">
                 <img v-bind:src="'../src/assets/slide3.jpg'" alt="thong firearms">
    </div>-->
    <h2 class="mt-4 mb-4">ปืนร้านทั้งหมด</h2>
    <h5>การแสดงรายการ</h5>
    {{ addWelfareGroup }}

    <b-form-radio-group
      v-model="searchSelected"
      :options="searchOptions"
      class="mb-3"
      value-field="item"
      text-field="name"
    >
    <b-form-checkbox
      id="checkbox-1"
      v-model="status"
      name="checkbox-1"
      value="แสดง"
      unchecked-value="ไม่แสดง"
      switch
      class="mr-3"
    >
      <strong>{{ status }}</strong>
      ปืนที่ถูกซ่อน
    </b-form-checkbox>
    </b-form-radio-group>
    <h5>สถานะคลัง</h5>
    <b-form-radio-group
      id="stock-filter"
      v-model="stockStatus"
      name="stock-filter"
      class="mb-3"
    >
      <b-form-radio value="ทั้งหมด">ทั้งหมด</b-form-radio>
      <b-form-radio value="มีของ">มีของ</b-form-radio>
      <b-form-radio value="หมด">หมด</b-form-radio>
    </b-form-radio-group>
    <div class="mb-3">
      Selected: <strong>{{ searchSelected }}</strong> | Sorting By:
      <b>{{ sortBy }}</b> | Results:
      <b>{{ filterArms.length }}</b>
    </div>
    <b-table
      :items="filterArms"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      responsive="sm"
      :tbody-tr-class="rowClass"
      :busy="!filterArms.length"
    >
      <template v-slot:cell(img)="data">
        <img
          v-bind:src="'/src/assets/product/' + data.item.img"
          width="70"
          :title="data.item.img"
        />{{ data.item.img }}
      </template>
      <template v-slot:cell(category)="data">
        <span :title="data.item.category">{{
          categorys[data.item.category]
        }}</span>
        <p>
          <b-badge variant="light">{{ data.item.category }}</b-badge>
        </p>
      </template>
      <template v-slot:cell(type)="data">
        <span :title="data.item.type">{{ type[data.item.type] }}</span>
        <p>
          <b-badge variant="light">{{ data.item.type }}</b-badge>
        </p>
      </template>
      <template v-slot:cell(brand)="data">
        <span :title="data.item.brand">{{ brand[data.item.brand] }}</span>
        <p>
          <b-badge variant="light">{{ data.item.brand }}</b-badge>
        </p>
      </template>
      <template v-slot:cell(inStock)="data">
        <small :title="data.item.inStock">
          <b-badge pill :variant="data.item.inStock != 0 ? `success` : `danger`"
            >&nbsp;</b-badge
          >
        </small>
      </template>
      <template v-slot:cell(detail)="row">
        <router-link
          v-if="row.item.isWelfare"
          v-bind:to="/welfare/ + row.item.id"
          target="_blank"
          ><b-button size="sm" variant="success"
            >ปืนสั้นสวัสดิการ</b-button
          ></router-link
        >
        <router-link v-else v-bind:to="/product/ + row.item.id" target="_blank"
          ><b-button size="sm" variant="danger">ปืนร้าน</b-button></router-link
        >
        <b-button size="sm" @click="row.toggleDetails" class="mr-2">
          {{ row.detailsShowing ? "Hide" : "Show" }} Details
        </b-button>
        <h2 v-if="row.item.inStock == 0" class="text-danger">OUT OF STOCK</h2>
        <p>{{ row.item.detail }}</p>
      </template>
      <template v-slot:row-details="row">
        <b-card>
          <b-table-simple hover small caption-top responsive>
            <caption>
              ข้อมูลทางเทคนิค
            </caption>
            <b-tbody>
              <b-tr>
                <b-th class="w-25">ความยาวทั้งหมด<sup>(นิ้ว)</sup></b-th>
                <b-td class="text-capitalize">{{
                  row.item.length ? row.item.length : "-"
                }}</b-td>
                <b-th class="">ขนาดกระสุน</b-th>
                <b-td class="text-capitalize w-75">{{
                  row.item.caliber
                    ? row.item.caliber.toString().replace("0", "")
                    : "-"
                }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="w-25">ความยาวลำกล้อง<sup>(นิ้ว)</sup></b-th>
                <b-td class="text-capitalize">{{
                  row.item.barrellength ? row.item.barrellength : "-"
                }}</b-td>
                <b-th class="w-25">บรรจุ<sup>(นัด)</sup></b-th>
                <b-td class="text-capitalize w-75">{{
                  row.item.capacity ? row.item.capacity : "-"
                }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="w-25">น้ำหนัก<sup>(กก.)</sup></b-th>
                <b-td class="text-capitalize">{{
                  row.item.weight ? row.item.weight : "-"
                }}</b-td>
                <b-th class="w-25">ศูนย์</b-th>
                <b-td class="text-capitalize w-75">{{
                  row.item.sights ? row.item.sights : "-"
                }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="w-25">ระบบความปลอดภัย</b-th>
                <b-td class="text-capitalize">{{
                  row.item.safety ? row.item.safety : "-"
                }}</b-td>
                <b-th class="">ลำกล้อง</b-th>
                <b-td class="text-capitalize w-75font-m">{{
                  row.item.barrel ? row.item.barrel : "-"
                }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="w-25">ระบบไก</b-th>
                <b-td class="text-capitalize">{{
                  row.item.trigger ? row.item.trigger : "-"
                }}</b-td>
                <b-th class="">{{
                  row.item.category == 1 ? "ทรงปืน" : "ระบบป้อนกระสุน"
                }}</b-th>
                <b-td class="text-capitalize w-75">{{
                  row.item.size || row.item.supplytype
                    ? row.item.category == 1
                      ? row.item.size
                      : row.item.supplytype
                    : "-"
                }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="w-25">{{
                  row.item.category == 1 ? "โครงปืน" : "ร่องแก้มพานท้าย"
                }}</b-th>
                <b-td class="text-capitalize w-25">{{
                  row.item.frame || row.item.cheekpiece
                    ? row.item.category == 1
                      ? row.item.frame
                      : row.item.cheekpiece
                    : "-"
                }}</b-td>
                <b-th class="">{{
                  row.item.category == 1 ? "ด้าม" : "ตัวช่วยลดแรงสะบัด"
                }}</b-th>
                <b-td class="text-capitalize w-75">{{
                  row.item.grips || row.item.compensator
                    ? row.item.category == 1
                      ? row.item.grips
                      : row.item.compensator
                    : "-"
                }}</b-td>
              </b-tr>
              <b-tr v-if="row.item.category == 2">
                <b-th class="w-25">ความยาวพานท้าย<sup>(นิ้ว)</sup></b-th>
                <b-td class="text-capitalize">{{
                  row.item.lop ? row.item.lop : "-"
                }}</b-td>
                <b-th class="">เกลียวปลาย</b-th>
                <b-td class="text-capitalize w-75">{{
                  row.item.thread ? row.item.thread : "-"
                }}</b-td>
              </b-tr>
              <b-tr v-if="row.item.category == 2">
                <b-th class="w-25">วัสดุพานท้าย</b-th>
                <b-td class="text-capitalize">{{
                  row.item.stock ? row.item.stock : "-"
                }}</b-td>
                <b-th class="">ผิวพานท้าย</b-th>
                <b-td class="text-capitalize w-75">{{
                  row.item.stocksurface ? row.item.stocksurface : "-"
                }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>

          <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
        </b-card>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>
          <span class="sr-only">Loading...</span>
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
import { db } from "../config_db";

//import { setupFirebase } from '../config_db'
// const firebase = setupFirebase({});

// var catid = parseInt(window.location.href.split("=").pop());
// let db = firebase.database();
let armsRef = db.ref("product");
let welsRef = db.ref("welfare");

export default {
  components: {
    name: "All"
  },
  firebase() {
    return {
      arms: armsRef,
      welfares: welsRef
    };
  },
  data() {
    return {
      status: "ไม่แสดง",
      stockStatus: "ทั้งหมด",
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "id", headerTitle: "id", label: "#", sortable: true },
        { key: "img", headerTitle: "img", label: "รูป", sortable: true },
        { key: "name", headerTitle: "name", label: "ชื่อปืน", sortable: true },
        {
          key: "category",
          headerTitle: "category",
          label: "หมวด",
          sortable: true
        },
        { key: "type", headerTitle: "type", label: "ประเภท", sortable: true },
        { key: "brand", headerTitle: "brand", label: "ยี่ห้อ", sortable: true },
        {
          key: "inStock",
          headerTitle: "inStock",
          label: "คลัง",
          sortable: true
        },
        {
          key: "detail",
          headerTitle: "detail",
          label: "รายละเอียด",
          sortable: false
        }
      ],
      searchSelected: "All",
      searchOptions: [
        { item: "All", name: "ทั้งหมด" },
        { item: "Shop", name: "ปืนร้าน" },
        { item: "Welfare", name: "ปืนสั้นสวัสดิการ" }
      ],
      // arms: [],
      // welfares: [],
      type: [
        "",
        "กึ่งอัตโนมัติ",
        "ลูกโม่",
        "ลูกซอง",
        "ลูกเลื่อน",
        "คานเหวี่ยง",
        "ไรเฟิล"
      ],
      categorys: ["", "ปืนสั้น", "ปืนยาว"],
      brand: [
        "",
        "BENELLI",
        "BERETTA",
        "BROWNING",
        "COLT",
        "CZ",
        "GLOCK",
        "HENRY",
        "REMINGTON",
        "SMITH&WESSON",
        "STANDARD MFG. (U.S.A.)",
        "TARAN TACTICAL INNOVATIONS JOHN WICK",
        "Zev Technologies",
        "BAIKAL",
        "CMMG",
        "TippMann",
        "DERYA",
        "STACCATO",
        "I.C.R.W.",
        "MOSSBERG",
        "MAXIM DEFENSE",
        "BUL Armory",
        "SIG SAUER",
        "PHOENIX TRINITY"
      ]
    };
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") {
        return;
      }
      if (item.show === false || item.show === "FALSE") {
        return "table-danger";
      }
    }
  },
  computed: {
    filterArms() {
      let filteredItems;

      if (this.searchSelected === "Shop") {
        filteredItems = this.arms.filter(item => {
          return this.status == "ไม่แสดง"
            ? typeof item.show == "undefined"
            : item;
        });
      } else if (this.searchSelected === "Welfare") {
        filteredItems = this.welfares.filter(item => {
          return this.status == "ไม่แสดง"
            ? typeof item.show == "undefined"
            : item;
        });
      } else {
        filteredItems = [...this.arms, ...this.welfares].filter(item => {
          return this.status == "ไม่แสดง"
            ? typeof item.show == "undefined"
            : item;
        });
      }

      // Apply stock filter
      if (this.stockStatus === "มีของ") {
        return filteredItems.filter(item => item.inStock !== 0);
      } else if (this.stockStatus === "หมด") {
        return filteredItems.filter(item => item.inStock === 0);
      }

      return filteredItems;
    },
    addWelfareGroup() {
      return this.welfares.forEach(e => {
        e.isWelfare = true;
      });
    }
  }
  // mounted(){
  //     this.$http.get('https://thongarms-2506.firebaseio.com/product.json').then(function(data){
  //      return data.json();
  //    }).then(function(data){
  //        var dataArray = [];
  //        var brandArray = [];
  //        for(let key in data){
  //           if(key==0){

  //           }else{
  //              dataArray.push(data[key]);
  //           }
  //        }
  //       console.log(dataArray);
  //           this.arms = dataArray;
  //    });
  // }
};
</script>



// WEBPACK FOOTER //
// src/component/all.vue